import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/fund/recharge-icon.png'
import _imports_1 from '@/assets/image/fund/change-icon.png'
import _imports_2 from '@/assets/image/fund/export-icon.png'
import _imports_3 from '@/assets/image/fund/balance-icon.png'
import _imports_4 from '@/assets/image/fund/record-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-931a076a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tabs-content"
}
const _hoisted_2 = { class: "demo-tabs" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_5 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "選択店舗口座（店舗別残高） ", -1))
const _hoisted_12 = { class: "fund-list" }
const _hoisted_13 = {
  key: 0,
  class: "fund-list-top"
}
const _hoisted_14 = { class: "fund-list-title" }
const _hoisted_15 = {
  key: 0,
  class: "subaccount-fund-country"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "btn-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0,
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1,
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { style: {"max-width":"244px","font-size":"14px"} }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "text rel" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_29 = { style: {"display":"inline-block"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_2,
  alt: "",
  style: {"display":"inline-block"}
}, null, -1))
const _hoisted_31 = { class: "flex flex-end" }
const _hoisted_32 = { class: "fund-recharge-content" }
const _hoisted_33 = { class: "fund-amount-item balance" }
const _hoisted_34 = { class: "fund-amount-left" }
const _hoisted_35 = { class: "text" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"244px","font-size":"14px"} }, [
  /*#__PURE__*/_createTextVNode(" ※この残高は直接注文に使えません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("店舗口座へ振替後、ご注文いただけます。 ")
], -1))
const _hoisted_37 = { class: "number" }
const _hoisted_38 = { class: "unit" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = { class: "jp-price" }
const _hoisted_41 = {
  key: 0,
  class: "frozen"
}
const _hoisted_42 = { class: "jp-price" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fund-amount-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_44 = {
  key: 0,
  class: "fund-amount-item record"
}
const _hoisted_45 = { class: "fund-amount-left" }
const _hoisted_46 = { class: "text" }
const _hoisted_47 = { class: "number" }
const _hoisted_48 = { class: "unit" }
const _hoisted_49 = { class: "jp-price" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fund-amount-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    referrerPolicy: "no-referrer",
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_51 = { class: "fund-table-content" }
const _hoisted_52 = {
  class: "flex-ter fund-search",
  style: {"margin-bottom":"34px","flex-wrap":"wrap"}
}
const _hoisted_53 = {
  key: 1,
  class: "mb_20"
}
const _hoisted_54 = {
  key: 2,
  class: "mb_20"
}
const _hoisted_55 = { class: "fund-table" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  key: 0,
  class: "look-more-detail"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode("...")
const _hoisted_62 = { class: "blur" }
const _hoisted_63 = { style: {"max-height":"200px","overflow-y":"auto"} }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = { key: 1 }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { key: 1 }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = {
  key: 0,
  class: "color"
}
const _hoisted_77 = {
  key: 1,
  class: "color"
}

import { QuestionFilled } from '@element-plus/icons-vue'
import { t, lang } from '@/plugins/i18n'
import { ref, reactive, computed, nextTick, toRaw, onMounted, watch, Ref } from 'vue'
import { useStore } from 'vuex'
import STable from '@/components/Table/index.vue'
import { getFundColumns, getSubFundColumns, tableConfig, formatPrice, secondFlowType } from './data'
import SelectIcon from '@/views/usercenter/ProductList/components/SelectIcon.vue'
import {
  getCustomerWalletList,
  queryFundFlow,
  getFundType,
  getUnCheckMoney,
  getCanTransformList,
  getFlowOneById,
  getBillListApi,
  getCustomerCashBackDetailApi,
  getWfTotalPriceApi,
  getBillInfo
} from '@/apis/fund'
import axios from 'axios'
import { getJapanTime, setStartDateTime, setEndDateTime, clearForm } from '@/util/common'
import { getMainCustomer } from '@/apis/user'
import { exportFileDownload } from '@/util/useExport'
import Recharge from './Recharge.vue'
import Transfer from './transfer.vue'
import PayoneerList from './PayoneerList.vue'
import FlowingDetail from './FlowingDetail.vue'
import { useRoute, useRouter } from 'vue-router'
import { useRtfix, isD2C, useSite2Station, useSite, isKO, isEN, isJA, isMultiStore } from '@/store'
import Guide from '@/components/guide/index.vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import { getVipCombo } from '@/apis/usercenter'
import { calc, getCurrentMonetaryUnit, formatMoneyDirection } from '@/util/useYan'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import ModalFeeTypeDetail from './components/ModalFeeTypeDetail.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { responseReceiptData, ASK_ENUM } from '@/views/setup/components/utils'
import ModalFundFlowContent from '@/views/fund/FundList/components/ModalFundFlowContent.vue'
import { request } from '@/config/request/interceptors'
import UploadBillExcel from './components/UploadBillExcel.vue'
import BalanceLowerSet from './components/balanceLowerSet.vue'
import CommonBalance from './components/commonBalance.vue'
enum VolumeSort {
  XS = 1,
  S = 2,
  M = 3,
  L = 4,
  XL = 5
}
interface FeeTypeDetailProps {
  typeName: string
  orderNum: string
  availableAmount: number
  date: string
  feeTypeList: { fundFlowName: string; subTypeName: string; proportion: number; proportionAmount: number }[];
  currencyCode: string
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)

const station = useSite2Station()
const currentMonetaryUnit = getCurrentMonetaryUnit()
const store = useStore()
const isSub = store.getters.isSub
const loginName = store.getters.user.loginName
const customerShopId = store.getters.curShop
const customerShopName = store.getters.shopname
const shopInfo = computed(() => store.getters.shopInfo)
// 校验是否是税金附加项白名单
const ischeckTaxAdditionWhiteList = ref(false)

const route = useRoute()
const router = useRouter()

const tableKey = ref(0)
// 选择国家钱包
const currencyCode: Ref<'CNY' | 'KRW'> = ref('CNY')
const getSelectInfo = () => {
  const selectInfo = FundCountry.find((item) => item.value === currencyCode.value)
  return selectInfo
}
// 改变钱包
const changeFundCountry = (val: 'CNY' | 'KRW') => {
  currencyCode.value = val
  const query = {
    ...route.query,
    platformOrderNo: '',
    currencyCode: val
  }

  tableKey.value = tableKey.value + 1
  searchForm.platformOrderNo = ''
  router.replace({ ...route, query })
}
watch(
  route,
  (v) => {
    const query = { ...v.query }
    // 如果没开通韩国仓，直接展示人民币
    if (!isMultiStore()) {
      currencyCode.value = 'CNY'
      return
    }
    // 做个兼容，只有为KRW展示韩元，否则字母拼错之类的一律默认CNY
    currencyCode.value = query.currencyCode === 'KRW' ? 'KRW' : 'CNY'
  },
  { immediate: true }
)

const FundCountry = [
  { value: 'CNY', label: t('人民币钱包'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/ChinaSquareIcon@3x.png' },
  { value: 'KRW', label: t('韩元钱包'), logo: 'https://static-s.theckb.com/BusinessMarket/Client/country/KoreaSquareIcon@3x.png' }
]

const orderNo = ref('')
const sku = ref('')
const loginFund = computed(() => {
  return t('主钱包')
})

const customerFund = computed(() => {
  return t('子钱包') + '(' + customerShopName + ')'
})

const type = computed(() => route.query.type)

// 搜索订单编号类型
const orderType = ref('platformOrderNo')
const subFundColumnsCmp = (columns: any) => {
  return orderType.value === 'platformOrderNo' ? columns.filter((v: any) => v.prop !== 'ordercustomNo') : columns
}
// 搜索sku
const skuType = ref('productSku')
const fundTab = ref()
const { name } = route as any
const activeMenu = name ? name.split('_')[0] : ''
if (activeMenu === 'CustomerFund') {
  fundTab.value = '1'
} else {
  fundTab.value = '2'
}

watch([skuType, orderType], () => {
  setTimeout(() => {
    refreshTable(true)
  }, 100)
})

const handleTab = () => {
  if (fundTab.value === '1') {
    router.push(useRtfix('CustomerFund', { query: { currencyCode: route.query.currencyCode } }))
  } else {
    router.push(useRtfix('StoreFund', { query: { currencyCode: route.query.currencyCode } }))
  }
}

onMounted(() => {
  init()
  // 获取wf金额待入账金额 抽成一个方法
  getWfTotalPrice()
  taTrack({
    event: TaEvent.PAGE_VIEW,
    value: {
      position: 'bill_notice'
    }
  })
})

const FundTypeDict: any = ref({})

// 主店铺
const FundTypeArr: any = ref([])
// 子店铺
const subFundTypeArr: any = ref([])

// 为主账户时转帐列表
const sub = ref([])
const main = ref()
const transferList = computed(() => {
  if (isSub) {
    return [main.value]
  }
  if (fundTab.value === '1') {
    return sub.value
  } else {
    return [store.getters.user]
  }
})

const init = async () => {
  request.wms.wms.baseConfigCheckTaxAdditionWhiteList().then(res => {
    ischeckTaxAdditionWhiteList.value = !!res.data
  })
  getUnCheckMoney({ currencyCode: currencyCode.value }).then(res => {
    unCheckMoney.value = res.data.unCheckCnyAmt
    unCheckMoneyJPY.value = res.data.unCheckAmt
  })
  getFundType().then((res: any) => {
    if (res.success) {
      // 美国站数据。需要过滤掉
      const filterList = [32, 33, 34]
      res.data = (res.data ?? []).filter((item: any) => !filterList.includes(item.type))
      for (const t of res.data) {
        FundTypeDict.value[t.type] = t.name
        if ([2, 10, 11, 12, 22, 24, 31].includes(t.type)) {
          FundTypeArr.value.push(t)
        } else {
          subFundTypeArr.value.push(t)
        }
        if ([19, 35, 1, 23].includes(t.type)) {
          // 主类型和子类型都加
          FundTypeArr.value.push(t)
        }
      }
    }
  })
  if (isSub) {
    getMainCustomer({
      token: store.getters.token
    }).then((res: any) => {
      if (res.success) {
        main.value = res.data
      }
    })
  } else {
    getCanTransformList().then((res: any) => {
      if (res.success) {
        sub.value = res.data
      }
    })
  }

  getCustomerWalletList({
    stationCode: station,
    currencyCode: currencyCode.value
  }).then((res: any) => {
    walletList.value = res.data
    refresh()
  })
}
// 监听钱包的变化
watch(() => currencyCode.value, (val) => {
  init()
  getWfTotalPrice()
})

const pageData = ref({
  page: 1,
  limit: 30
})

const walletList: any = ref([])
const unCheckMoney: any = ref(0)
const unCheckMoneyJPY: any = ref(0)

const hasPlatformOrderNo = ref(!!route.query.platformOrderNo)

// const bizContentCustomerList = computed(() => { return route.query.bizContentCustomerList ? String(route.query.bizContentCustomerList).split(',') : null })
const bizContentCustomerList = ref(route.query.bizContentCustomerList ? String(route.query.bizContentCustomerList).split(',') : null)
const filterData = computed(() => {
  if (hasPlatformOrderNo.value) {
    return {
      platformOrderNo: route.query.platformOrderNo,
      customerShopId: walletInfo?.value?.customerShopId,
      fundFlowType: Number(route.query.fundFlowType) || '',
      bizContentCustomer: null,
      currencyCode: currencyCode.value
    }
  }
  const params: any = {
    ...searchForm,
    currencyCode: currencyCode.value,
    customerShopId: walletInfo?.value?.customerShopId
  }
  if (orderNo.value) {
    params[orderType.value] = orderNo.value
  }
  if (sku.value) {
    params[skuType.value] = sku.value
  }
  if (params.fundFlowType === 12 && searchForm.bizContentCustomer) {
    params.bizContentLeftLike = searchForm.bizContentCustomer
    delete params.bizContentCustomer
  }
  return params
})

const clear = () => {
  bizContentCustomerList.value = null
  clearForm(searchForm)
  searchForm.bizContentCustomer = null
  searchForm.deliverOrderNo = null
  refreshTable()
  orderNo.value = ''
  sku.value = ''
}

const refresh = () => {
  getWallet()
  refreshTable()
}

const walletInfo: any = ref({})
const balance = ref(0) // 余额
const isSubBalance = (val: any) => {
  const availableAmount = val?.availableAmount ?? 0
  const frozenAmount = val?.frozenAmount ?? 0
  // const total = availableAmount - frozenAmount * 2
  const total = availableAmount - frozenAmount
  return total > 0 ? Number(total.toFixed(2)) : 0
}

// 获取钱包列表
const getWallet = () => {
  if (isSub) {
    walletInfo.value = walletList?.value?.find?.((e: any) => e.customerShopId === customerShopId)
    balance.value = isSubBalance(walletInfo?.value)
    return
  }
  if (fundTab.value === '1') {
    walletInfo.value = walletList?.value?.find?.((e: any) => e.accountType === 1)
    balance.value = walletInfo.value?.availableAmount || 0
  } else {
    walletInfo.value = walletList?.value?.find?.((e: any) => e.customerShopId === customerShopId)
    balance.value = isSubBalance(walletInfo.value)
  }
}

const searchForm: any = reactive({
  createTimeStart: '',
  createTimeEnd: '',
  fundFlowType: Number(route.query.fundFlowType) || '',
  platformOrderNo: route.query.platformOrderNo || null,
  deliverOrderNo: route.query.deliverOrderNo || null,
  bizContentCustomer: route.query.bizContentCustomer ? t(String(route.query.bizContentCustomer)) : null
})
console.log(searchForm, 'searchForm')

const searchDate = computed({
  get: () => [searchForm.createTimeStart, searchForm.createTimeEnd],
  set: (newVal) => {
    searchForm.createTimeStart = setStartDateTime(newVal?.[0] ?? '')
    searchForm.createTimeEnd = setEndDateTime(newVal?.[1] ?? '')
  }
})

const STableRef = ref()
const refreshTable = (type?: boolean) => {
  if (type) {
    bizContentCustomerList.value = null
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
    if (hasPlatformOrderNo.value) hasPlatformOrderNo.value = false
  })
}

const modalFundFlowContentRef = ref<InstanceType<typeof ModalFundFlowContent>>()

const confirmDownLoad = (row: any, headerName?: string) => {
  row.downloadLoading = true
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/settlement/recharge/manager/balance/recharge/download',
    data: {
      balanceRechargeId: row.bizId,
      documentHeader: headerName
    },
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    exportFileDownload(res, { type: 'application/pdf', name: t('收据') })
  }).finally(() => { row.downloadLoading = false })
}
const download = async (row: any) => {
  if (!isJA()) {
    confirmDownLoad(row)
    return
  }
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  // 如果不需要询问，那么直接下载
  if (lastUseData.askEveryTime === ASK_ENUM.NO_ASK) {
    confirmDownLoad(row, lastUseData.content)
    return
  }
  modalFundFlowContentRef.value?.open(lastUseData.content, (value: string) => {
    confirmDownLoad(row, value)
  })
}

const exportLoading = ref(false)
const exportExcel = () => {
  if (exportLoading.value) return
  exportLoading.value = true
  const url =
    !isSub && fundTab.value === '1'
      ? '/settlement/wallet/exportMainCustomerFundFlow'
      : '/settlement/wallet/exportShopFundFlow/es'
  axios({
    method: 'POST',
    url: process.env.VUE_APP_URL + url,
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    },
    data: {
      ...filterData.value,
      currencyCode: currencyCode.value
    }
  }).then((res: any) => {
    exportFileDownload(res, { name: t('流水') })
  }).finally(() => {
    exportLoading.value = false
  })
}

const rechargeVisible = ref(false)
const transferVisible = ref(false)
const payoneerVisible = ref(false)

const flowingDetailVisible = ref(false)
const rowItem = ref()
const rowItemDetail = ref()
const openDetail = (row: any) => {
  if (row.fundFlowType === 23) {
    // 账单跳转
    router.push(useRtfix('BillList', { query: { id: row.bizId, type: fundTab.value, billPayStatus: 1, currencyCode: currencyCode.value } }))
    return
  }
  row.infoLoading = true
  rowItem.value = { ...row, fundFlowTypeName: FundTypeDict.value[row.fundFlowType] }

  if (rowItem.value.fundFlowType === 18) {
    rowItemDetail.value = rowItem.value
    flowingDetailVisible.value = true
    row.infoLoading = false
  } else if (row.fundFlowType === 24) {
    // 返现
    getCustomerCashBackDetailApi({
      bizId: row.bizId
    }).then((res: any) => {
      rowItemDetail.value = res.data
      flowingDetailVisible.value = true
    }).finally(() => { row.infoLoading = false })
  } else if (row.fundFlowType === 6 && [28, 76].includes(row.fundFlowDetailType)) {
    // 库存保管 包裹滞留
    getBillInfo({
      billNo: row.bizId
    }).then(res => {
      rowItemDetail.value = {
        ...res.data,
        ...row,
        fundFlowTypeName: FundTypeDict.value[row.fundFlowType],
        priceRulesList: Object.keys(res.data.priceRules).map(v => {
          return {
            ...res.data.priceRules[v],
            ruleKey: v
          }
        }).sort((a: any, b: any) => {
          return VolumeSort[a.ruleKey] < VolumeSort[b.ruleKey] ? -1 : 1
        })
      }
      flowingDetailVisible.value = true
    }).finally(() => { row.infoLoading = false })
  } else {
    getFlowOneById({
      id: row.walletFundFlowId
    }).then((res: any) => {
      rowItemDetail.value = res.data
      flowingDetailVisible.value = true
    }).finally(() => { row.infoLoading = false })
  }
}

// 获取待支付账单数量
const billNum = ref(0)
getBillListApi({
  pageSize: 1,
  pageNum: 1,
  billPayStatus: 2,
  mainOrSubBill: !isSub
}).then((res: any) => {
  if (res.success) {
    billNum.value = res.data.total
  }
})

const secondFlowTypeList = ref({
  ...secondFlowType
})
secondFlowTypeList.value[10] = store.getters.user.customerShopList.map((v: any) => { return { name: v.customerShopName } })
secondFlowTypeList.value[11] = store.getters.user.customerShopList.map((v: any) => { return { name: v.customerShopName } })
getVipCombo().then((res: any) => {
  secondFlowTypeList.value[12] = res.data.map((v: any) => {
    return {
      name: v.priceName
    }
  })
})

const wfPrice = ref(0)
const wfPriceJPY = ref(0)
const getWfTotalPrice = () => getWfTotalPriceApi({
  rechargeType: 1,
  balanceRechargeStatusList: [1, 2, 6],
  customerId: store.getters.user.customerId,
  payChannel: 5,
  rechargeCurrencyCode: currencyCode.value
}).then((res: any) => {
  wfPrice.value = res.data?.rechargeCnyAmount || 0
  wfPriceJPY.value = res.data?.rechargeAmount || 0
})

const feeTypeDetail = ref<Partial<FeeTypeDetailProps>>({})
const modalFeeTypeVisit = ref(false)
// 查看费用详情
const lookFoundDetail = async (row: any) => {
  const res = await getFlowOneById({
    id: row.walletFundFlowId
  })
  feeTypeDetail.value = {
    typeName: res.data.bizContentCustomer,
    orderNum: res.data.orderNo,
    availableAmount: res.data.afterAvailableAmount,
    date: res.data.updateTime,
    feeTypeList: res.data.fundTypeRelationRespDTOList,
    currencyCode: res.data.currencyCode
  }
  modalFeeTypeVisit.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_table_button = _resolveComponent("table-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(useSite)())
  }, [
    _createVNode(CommonBalance, {
      fundTab: fundTab.value,
      isSub: _unref(isSub),
      currencyCode: currencyCode.value,
      transferVisible: transferVisible.value,
      showTransfer: () => transferVisible.value = true,
      exportExcel: exportExcel,
      accountBalance: walletInfo.value?.availableAmount || 0,
      accountBalanceJPY: _unref(formatMoneyDirection)(_unref(formatPrice)(_unref(calc)(walletInfo.value?.availableAmount || 0, currencyCode.value))),
      frozenAmount: walletInfo.value?.frozenAmount || 0,
      unCheckMoneyJPY: unCheckMoneyJPY.value,
      wfPriceJPY: wfPriceJPY.value,
      unCheckMoney: unCheckMoney.value,
      wfPrice: wfPrice.value,
      customerShopName: _unref(customerShopName),
      changeFundCountry: changeFundCountry,
      changeTab: (e) => {fundTab.value = e; handleTab()}
    }, null, 8, ["fundTab", "isSub", "currencyCode", "transferVisible", "showTransfer", "accountBalance", "accountBalanceJPY", "frozenAmount", "unCheckMoneyJPY", "wfPriceJPY", "unCheckMoney", "wfPrice", "customerShopName", "changeTab"]),
    (!_unref(isSub) && false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => {fundTab.value = '1'; handleTab()}),
              class: _normalizeClass(`tabs-default ${fundTab.value === '1' ? 'tabs-active' : ''}`)
            }, [
              (!_unref(isMultiStore)())
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(loginFund)), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        style: {"width":"21px","margin-right":"4px"},
                        src: getSelectInfo()?.logo,
                        alt: ""
                      }, null, 8, _hoisted_6),
                      _createElementVNode("span", null, _toDisplayString(getSelectInfo()?.label), 1)
                    ]),
                    _createVNode(_component_el_select, {
                      size: "small",
                      style: {"width":"30px"},
                      class: "select-no-border-special-nolabel",
                      "popper-class": `select-no-border-special-popper-nolabel-fund${_unref(lang)}`,
                      "model-value": currencyCode.value,
                      onChange: changeFundCountry,
                      "suffix-icon": SelectIcon
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FundCountry, (country) => {
                          return _createVNode(_component_el_option, {
                            size: "small",
                            key: country.value,
                            label: country.label,
                            value: country.value
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("img", {
                                  style: {"width":"21px","margin-right":"4px"},
                                  src: country.logo,
                                  alt: ""
                                }, null, 8, _hoisted_8),
                                _createElementVNode("span", null, _toDisplayString(country.label), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["popper-class", "model-value"])
                  ])),
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_el_tooltip, {
                  content: _unref(t)('※資金チャージ、各店舗への資金振替、会員費支払いのみ対応可能'),
                  placement: "top",
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"font-size":"16px","margin-left":"10px","vertical-align":"sub"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(QuestionFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content"])
              ])
            ], 2),
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => {fundTab.value = '2'; handleTab()}),
                  class: _normalizeClass(`tabs-default ${fundTab.value === '2' ? 'tabs-active' : ''}`)
                }, [
                  _createVNode(_component_el_tooltip, {
                    effect: "light",
                    placement: "top",
                    "popper-class": "tool-tip-no-border fund-tool"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, " この店舗の口座を表示中です：" + _toDisplayString(_unref(customerShopName)), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })
                ], 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {fundTab.value = '2'; handleTab()}),
                  class: _normalizeClass(`tabs-default ${fundTab.value === '2' ? 'tabs-active' : ''}`)
                }, _toDisplayString(_unref(customerFund)), 3))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (_unref(isMultiStore)() && _unref(isSub))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_unref(isMultiStore)())
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "selected-country-icon",
                          src: FundCountry.find((item) => item.value === currencyCode.value)?.logo,
                          alt: ""
                        }, null, 8, _hoisted_16))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_select, {
                      size: "small",
                      style: {"width":"280px"},
                      class: "select-no-border-special",
                      "popper-class": "select-no-border-special-popper",
                      "model-value": currencyCode.value,
                      onChange: changeFundCountry,
                      "suffix-icon": SelectIcon
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(FundCountry, (country) => {
                          return _createVNode(_component_el_option, {
                            size: "small",
                            key: country.value,
                            label: country.label,
                            value: country.value
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("img", {
                                  style: {"width":"21px","margin-right":"4px"},
                                  src: country.logo,
                                  alt: ""
                                }, null, 8, _hoisted_18),
                                _createElementVNode("span", null, _toDisplayString(country.label), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "value"])
                        }), 64))
                      ]),
                      _: 1
                    }, 8, ["model-value"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                (!_unref(isSub) && fundTab.value === '1')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "btn-item",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push(_unref(useRtfix)('Recharge', { query: { currencyCode: currencyCode.value } })))),
                      style: {"display":"inline-block"}
                    }, [
                      _hoisted_20,
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('充值')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "btn-item blue rel",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (transferVisible.value = true))
                }, [
                  _hoisted_21,
                  (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(fundTab.value === '2' ? '親口座へ振替' : _unref(t)('转账')), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(t)('转账')), 1)),
                  (_unref(isJA)() && fundTab.value === '1')
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 2,
                        effect: "light",
                        placement: "top",
                        "popper-class": "tool-tip-no-border"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('待付款提醒')), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createTextVNode(_toDisplayString(_unref(t)('発注は店舗で行いますので、')), 1),
                              _hoisted_27,
                              _createTextVNode(_toDisplayString(_unref(t)('ご注文前に、まず振替による店舗へ資金を移動する必要があります')), 1)
                            ]),
                            _hoisted_28
                          ])
                        ]),
                        default: _withCtx(() => [
                          (fundTab.value === '1')
                            ? (_openBlock(), _createBlock(SvgIcon, {
                                key: 0,
                                name: "提示",
                                style: {"font-size":"16px","margin-left":"6px","color":"#000","display":"inline-block"}
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (fundTab.value === '2')
                    ? (_openBlock(), _createBlock(UploadBillExcel, { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "btn-item green",
                  onClick: exportExcel
                }, [
                  _hoisted_30,
                  _createElementVNode("span", null, _toDisplayString(_unref(t)('表格导出')), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  (!_unref(isSub))
                    ? (_openBlock(), _createBlock(BalanceLowerSet, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createTextVNode(_toDisplayString(_unref(t)('可用余额')) + " ", 1),
                    (_unref(isJA)() && fundTab.value === '1')
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          effect: "light",
                          placement: "top",
                          "popper-class": "tool-tip-no-border"
                        }, {
                          content: _withCtx(() => [
                            _hoisted_36
                          ]),
                          default: _withCtx(() => [
                            _createVNode(SvgIcon, {
                              name: "提示",
                              style: {"font-size":"16px","margin-left":"6px","color":"#000"}
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_unref(formatPrice)(walletInfo.value?.availableAmount || 0)), 1),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(currencyCode.value
                === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
                    _hoisted_39,
                    _createElementVNode("span", _hoisted_40, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)(_unref(calc)(walletInfo.value?.availableAmount || 0, currencyCode.value)))) + ")", 1)
                  ]),
                  (!(!_unref(isSub) && fundTab.value === '1'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('冻结金额')), 1),
                        _createElementVNode("span", null, " " + _toDisplayString(_unref(formatPrice)(walletInfo.value?.frozenAmount || 0)), 1),
                        _createElementVNode("span", null, _toDisplayString(currencyCode.value === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
                        _createElementVNode("span", _hoisted_42, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)(_unref(calc)(walletInfo.value?.frozenAmount || 0,
                  currencyCode.value)))) + ")", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_43
              ]),
              (!_unref(isSub) && fundTab.value === '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('未入账金额')), 1),
                      _createElementVNode("div", _hoisted_47, [
                        _createTextVNode(_toDisplayString(_unref(formatPrice)((unCheckMoney.value + wfPrice.value)?.toFixed?.(2)) || 0), 1),
                        _createElementVNode("span", _hoisted_48, _toDisplayString(currencyCode.value === 'KRW' ? _unref(t)("KRW") : _unref(t)("元")), 1),
                        _createElementVNode("span", _hoisted_49, "(" + _toDisplayString(_unref(formatMoneyDirection)(_unref(formatPrice)((unCheckMoneyJPY.value +
                  wfPriceJPY.value)?.toFixed?.(_unref(isEN)() ? 2 : 0) || 0))) + ")", 1)
                      ])
                    ]),
                    _hoisted_50
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_date_picker, {
            class: "mb_20",
            style: {"margin-right":"20px","width":"240px"},
            modelValue: _unref(searchDate),
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
            type: "daterange",
            "range-separator": "-",
            "start-placeholder": _unref(t)('开始时间'),
            "end-placeholder": _unref(t)('结束时间'),
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            "popper-class": "mb_20"
          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"]),
          _createVNode(_component_el_select, {
            modelValue: _unref(searchForm).fundFlowType,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchForm).fundFlowType) = $event)),
            style: {"margin-right":"20px","width":"240px"},
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(searchForm).bizContentCustomer = null)),
            class: "mb_20"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: _unref(t)('全部'),
                value: ""
              }, null, 8, ["label"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((!_unref(isSub) && fundTab.value === '1') ? FundTypeArr.value : subFundTypeArr.value, (v) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: v.type,
                  label: v.name,
                  value: v.type
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_unref(searchForm).fundFlowType && secondFlowTypeList.value[_unref(searchForm).fundFlowType] && secondFlowTypeList.value[_unref(searchForm).fundFlowType].length > 0)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: _unref(searchForm).bizContentCustomer,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchForm).bizContentCustomer) = $event)),
                style: {"margin-right":"20px","width":"240px"},
                class: "mb_20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: _unref(t)('全部'),
                    value: null
                  }, null, 8, ["label"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondFlowTypeList.value[_unref(searchForm).fundFlowType], (v) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: v.name
                    }, [
                      ((v.name !== _unref(t)('国际运费') && v.name !== _unref(t)('关税报销')) || (((v.name === _unref(t)('国际运费') || v.name === _unref(t)('关税报销')) && ischeckTaxAdditionWhiteList.value)))
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: v.name,
                            value: v.name
                          }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (fundTab.value === '2')
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _createVNode(_component_el_select, {
                  style: {"margin-right":"20px","width":"160px"},
                  modelValue: orderType.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((orderType).value = $event)),
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (orderNo.value = ''))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('THE CKB订单编号'),
                      value: "platformOrderNo"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('客户订单编号'),
                      value: "customerOrderNo"
                    }, null, 8, ["label"]),
                    (_unref(shopInfo).authStatus === '1' && _unref(isD2C)())
                      ? (_openBlock(), _createBlock(_component_el_option, {
                          key: 0,
                          label: _unref(t)('订单') + ['', ' Base', ' Shopify', ' STORES'][_unref(shopInfo).customerShopPlatform],
                          value: "orderName"
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: orderNo.value,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((orderNo).value = $event)),
                  style: {"width":"200px","margin-right":"20px"},
                  placeholder: _unref(t)('请输入')
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (fundTab.value === '2' && [0, 3, 4, 6, 8, 9, 15].includes(Number(_unref(searchForm).fundFlowType)))
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createVNode(_component_el_select, {
                  style: {"margin-right":"20px","width":"240px"},
                  modelValue: skuType.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((skuType).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('平台商品SKU'),
                      value: "productSku"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('客户商品sku'),
                      value: "customerProductMsku"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: sku.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((sku).value = $event)),
                  style: {"width":"200px","margin-right":"20px"},
                  placeholder: _unref(t)('请输入')
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true),
          (fundTab.value !== '1')
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 3,
                type: "text",
                modelValue: _unref(searchForm).deliverOrderNo,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(searchForm).deliverOrderNo) = $event)),
                style: {"width":"200px","margin-right":"20px"},
                placeholder: _unref(t)('请输入THE CKB发货单号'),
                class: "mb_20"
              }, null, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (refreshTable(true))),
            class: "mb_20"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('查询')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: clear,
            class: "mb_20"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createVNode(STable, {
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            key: tableKey.value,
            filterData: { ..._unref(filterData), bizContentCustomerList: bizContentCustomerList.value },
            api: _unref(queryFundFlow),
            columns: (!_unref(isSub) && fundTab.value === '1') ? _unref(getFundColumns)(currencyCode.value) : subFundColumnsCmp(_unref(getSubFundColumns)(currencyCode.value)),
            "page-data": pageData.value,
            "onUpdate:page-data": _cache[16] || (_cache[16] = ($event: any) => ((pageData).value = $event)),
            tableConfig: _unref(tableConfig),
            isImmediatelyExec: false
          }, {
            changeAmount: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.changeType === 1 ? '-' : '+') + " " + _toDisplayString(row.changeAmount ?? 0), 1)
            ]),
            fundFlowType: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(FundTypeDict.value[row.fundFlowType]), 1)
            ]),
            bizContentCustomer: _withCtx(({ row }) => [
              (![3, 4, 5, 9, 13, 14, 18, 25].includes(row.fundFlowType))
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    (row.fundFlowType === 8)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(row.bizContentCustomer ? row.bizContentCustomer : '(仮払)商品代金・商品オプション費用'), 1))
                      : (row.fundFlowType === 19 || row.fundFlowType === 23)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            (row.fundFlowType === 19 && !row.relationRespDTOList?.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(row.bizContentCustomer), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.relationRespDTOList?.slice(0, 2), (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: item.fundFlowName
                                    }, _toDisplayString(item.fundFlowName) + " " + _toDisplayString(item.subTypeName !== '-' ? '-' + item.subTypeName : '') + " " + _toDisplayString(item.proportionAmount), 1))
                                  }), 128)),
                                  _createVNode(_component_el_popover, {
                                    placement: "top",
                                    width: 300,
                                    trigger: "click",
                                    "popper-class": "fundlist-fee-instructions-popover"
                                  }, {
                                    reference: _withCtx(() => [
                                      (row.relationRespDTOList?.length > 2)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                                            _hoisted_61,
                                            _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(t)('详情')) + ">", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_63, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.relationRespDTOList, (item1) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "fee-type-row",
                                            key: item1.fundFlowType
                                          }, _toDisplayString(item1.fundFlowName) + " " + _toDisplayString(item1?.subTypeName !== '-' ? '-' + item1.subTypeName : '') + " " + _toDisplayString(item1.proportionAmount), 1))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(row.bizContentCustomer), 1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            updateTime: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.updateTime)), 1)
            ]),
            handler: _withCtx(({ scope }) => [
              (scope.row.showDetailFlag && scope.row.fundFlowType === 19)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 0,
                    title: _unref(t)('详情'),
                    onClick: ($event: any) => (lookFoundDetail(scope.row))
                  }, null, 8, ["title", "onClick"]))
                : _createCommentVNode("", true),
              ([3, 4, 5, 6, 8, 9, 13, 14, 15, 16, 18, 23, 24, 27, 28, 29, 67, 36, 37, 38].includes(scope.row.fundFlowType))
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 1,
                    title: _unref(t)('详情'),
                    loading: scope.row.infoLoading,
                    onClick: ($event: any) => (openDetail(scope.row))
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true),
              (scope.row.fundFlowType === 1 && scope.row.bizContentCustomer !== 'PAYPAL充值(会员续费产生)' && scope.row.bizType !== 51)
                ? (_openBlock(), _createBlock(_component_table_button, {
                    key: 2,
                    title: _unref(t)('收据下载'),
                    loading: scope.row.downloadLoading,
                    onClick: ($event: any) => (download(scope.row))
                  }, null, 8, ["title", "loading", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            orderNo: _withCtx(({ row }) => [
              ((row.platformOrderNo) !== '-')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('OrderList', { query: { platformOrderNo: row.platformOrderNo } })))
                  }, _toDisplayString(row.platformOrderNo), 9, _hoisted_65))
                : (_openBlock(), _createElementBlock("span", _hoisted_66, "-")),
              _createElementVNode("div", null, _toDisplayString(row.orderTitle === '-' ? '' : row.orderTitle), 1)
            ]),
            ordercustomNoHead: _withCtx(() => [
              _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(t)('客户订单编号')), 513), [
                [_vShow, orderType.value === 'customerOrderNo']
              ]),
              _withDirectives(_createElementVNode("span", null, _toDisplayString(_unref(t)('订单') + ['', ' Base', ' Shopify',
                ' STORES'][_unref(shopInfo).customerShopPlatform]), 513), [
                [_vShow, orderType.value === 'orderName']
              ])
            ]),
            ordercustomNo: _withCtx(({ row }) => [
              (orderType.value === 'customerOrderNo')
                ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(row.customerOrderNo ?? '-'), 1))
                : _createCommentVNode("", true),
              (orderType.value === 'orderName')
                ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(row.orderName ?? '-'), 1))
                : _createCommentVNode("", true)
            ]),
            deliverOrderNo: _withCtx(({ row }) => [
              (row.deliverOrderNo !== '-' && !_unref(isD2C)())
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('ShippingInfo', { query: { deliveryTaskCode: row.deliverOrderNo } })))
                    }, _toDisplayString(row.deliverOrderNo), 9, _hoisted_70),
                    _hoisted_71,
                    _createTextVNode(_toDisplayString(row.deliverTitle), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_72, [
                    ((!row.platformOrderNo || row.platformOrderNo === '-') && _unref(isD2C)())
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => (_unref(router).push(_unref(useRtfix)('ShippingInfo', {query: {deliveryTaskCode: row.deliverOrderNo}})))
                        }, _toDisplayString(row.deliverOrderNo), 9, _hoisted_73))
                      : (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(row.deliverOrderNo), 1)),
                    _hoisted_75,
                    _createTextVNode(" " + _toDisplayString(row.deliverTitle === '-' ? '' : row.deliverTitle), 1)
                  ]))
            ]),
            skuHead: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(skuType.value === 'productSku' ? _unref(t)('平台商品SKU') : _unref(t)('客户商品sku')), 1)
            ]),
            sku: _withCtx(({ row }) => [
              (skuType.value === 'productSku')
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, _toDisplayString(row.productSkuList?.find?.(v => v === sku.value) ?? row.productSkuList?.[0] ?? '-'), 1))
                : (skuType.value === 'customerProductMsku')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(row.customerProductSkuList?.find?.(v => v === sku.value) ?? row.customerProductSkuList?.[0] ?? '-'), 1))
                  : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["filterData", "api", "columns", "page-data", "tableConfig"])
        ]),
        _createVNode(PayoneerList, {
          visible: payoneerVisible.value,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((payoneerVisible).value = $event))
        }, null, 8, ["visible"]),
        _createVNode(Transfer, {
          visible: transferVisible.value,
          "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((transferVisible).value = $event)),
          isSub: !(!_unref(isSub) && fundTab.value === '1'),
          balance: balance.value,
          "transfer-list": _unref(transferList),
          onRefresh: init,
          currencyCode: currencyCode.value
        }, null, 8, ["visible", "isSub", "balance", "transfer-list", "currencyCode"]),
        _createVNode(FlowingDetail, {
          visible: flowingDetailVisible.value,
          "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((flowingDetailVisible).value = $event)),
          rowItem: rowItem.value,
          rowItemDetail: rowItemDetail.value,
          FundTypeDict: FundTypeDict.value
        }, null, 8, ["visible", "rowItem", "rowItemDetail", "FundTypeDict"]),
        _createVNode(ModalFeeTypeDetail, {
          visible: modalFeeTypeVisit.value,
          "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((modalFeeTypeVisit).value = $event)),
          feeTypeDetail: feeTypeDetail.value
        }, null, 8, ["visible", "feeTypeDetail"]),
        _createVNode(ModalFundFlowContent, {
          ref: (_value, _refs) => {
            _refs['modalFundFlowContentRef'] = _value
            modalFundFlowContentRef.value = _value
          }
        }, null, 512)
      ])
    ], 512), [
      [_directive_loading, exportLoading.value]
    ]),
    (_unref(isD2C)() && !_unref(isSub))
      ? (_openBlock(), _createBlock(Guide, {
          key: 1,
          name: "d2c-customer-fund"
        }))
      : _createCommentVNode("", true),
    (_unref(isD2C)() && _unref(isSub))
      ? (_openBlock(), _createBlock(Guide, {
          key: 2,
          name: "d2c-store-fund"
        }))
      : _createCommentVNode("", true),
    (!_unref(isD2C)() && !_unref(isSub))
      ? (_openBlock(), _createBlock(Guide, {
          key: 3,
          name: "b2b-customer-fund"
        }))
      : _createCommentVNode("", true),
    (!_unref(isD2C)() && _unref(isSub))
      ? (_openBlock(), _createBlock(Guide, {
          key: 4,
          name: "b2b-store-fund"
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})